import { isServer } from "@tanstack/react-query";
import { getEnv } from "./env";
import { supportedTWTimezones } from "./tradingview/supported-timezones";
import { Timezone } from "../../public/static/charting_library/charting_library";

export const isDevelopment =
  getEnv.VITE_ENV === "development" || getEnv.NODE_ENV === "development";

export const isChromium =
  (typeof navigator !== "undefined" &&
    !!navigator.userAgent &&
    (navigator.userAgent.toLowerCase().includes("chromium") ||
      navigator.userAgent.toLowerCase().includes("chrome"))) ||
  (!isServer && !!window.chrome);

export function getOffsetMinutes(timeZone: string, date: Date): number {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const parts = dtf.formatToParts(date);
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  const asUTC = Date.UTC(
    Number(map.year),
    Number(map.month) - 1,
    Number(map.day),
    Number(map.hour),
    Number(map.minute),
    Number(map.second),
  );
  return (asUTC - date.getTime()) / 60000;
}

export function findClosestSupportedTimezone(userTimezone: string): Timezone {
  const now = new Date();
  if (supportedTWTimezones.includes(userTimezone as Timezone))
    return userTimezone as Timezone;

  const userOffset = getOffsetMinutes(userTimezone, now);
  let best = "Etc/UTC" as Timezone;
  let bestDiff = Number.POSITIVE_INFINITY;

  for (const tz of supportedTWTimezones) {
    const off = getOffsetMinutes(tz, now);
    const diff = Math.abs(off - userOffset);
    if (diff < bestDiff) {
      bestDiff = diff;
      best = tz;
    }
  }
  return best;
}
